import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSubscription } from "@/hooks/useSubscription";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle, Loader2 } from "lucide-react";
import { PlanBadge } from "@/components/PlanBadge";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { subscription, loading, refetch } = useSubscription();

  useEffect(() => {
    // Refetch subscription status when component mounts
    refetch();
  }, [refetch]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-secondary/20">
        <Card className="w-full max-w-md mx-4">
          <CardContent className="pt-6 flex flex-col items-center gap-4">
            <Loader2 className="h-12 w-12 animate-spin text-primary" />
            <p className="text-muted-foreground">Subscription wird geladen...</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-secondary/20 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center space-y-4">
          <div className="flex justify-center">
            <CheckCircle className="h-16 w-16 text-green-500" />
          </div>
          <CardTitle className="text-2xl">Zahlung erfolgreich!</CardTitle>
          <CardDescription>
            Vielen Dank für Ihr Vertrauen. Ihr Abonnement wurde erfolgreich aktiviert.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-secondary/50 rounded-lg p-4 space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Aktueller Plan:</span>
              <PlanBadge plan={subscription?.plan_type || "free"} />
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Status:</span>
              <span className="text-sm font-medium capitalize">{subscription?.status || "active"}</span>
            </div>
            {subscription?.current_period_end && (
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">Gültig bis:</span>
                <span className="text-sm font-medium">
                  {new Date(subscription.current_period_end).toLocaleDateString("de-DE")}
                </span>
              </div>
            )}
          </div>

          <div className="space-y-2">
            <Button 
              onClick={() => navigate("/create")} 
              className="w-full"
            >
              Jetzt Profil erstellen
            </Button>
            <Button 
              onClick={() => navigate("/")} 
              variant="outline" 
              className="w-full"
            >
              Zur Startseite
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSuccess;
